import { render, staticRenderFns } from "./deviceScreenConfig.vue?vue&type=template&id=e060639e&scoped=true"
import script from "./deviceScreenConfig.vue?vue&type=script&lang=js"
export * from "./deviceScreenConfig.vue?vue&type=script&lang=js"
import style0 from "./deviceScreenConfig.vue?vue&type=style&index=0&id=e060639e&prod&lang=scss&scoped=true"
import style1 from "./deviceScreenConfig.vue?vue&type=style&index=1&id=e060639e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_prettier@2.8.8_vue-template-compiler@2.7.16_webpack@5.101.3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e060639e",
  null
  
)

export default component.exports